import { A } from "@solidjs/router";

// Stuck to the bottom of the screen from md up. On a phone the text wraps onto
// several lines, so a fixed footer would cover a good part of every page; there it
// simply sits at the end of the page instead.
export const Footer = () => {
	return (
		<>
			{/* A fixed footer takes no room in the page, so without this the last
			    stretch of every page (about a footer's height) sat underneath it
			    and could never be scrolled into view. */}
			<div class="hidden md:block h-32" aria-hidden="true" />

			<footer class="bg-primary mt-6 py-4 md:py-6 px-4 md:fixed md:bottom-0 w-full text-center text-xs md:text-sm">
				<div class="main-container text-base md:text-xl mb-2">
					<A href="/privacy-policy" class="hover:underline">
						Privacy Policy
					</A>{" "}
					|{" "}
					<A href="/terms-and-conditions" class="hover:underline">
						Terms and Conditions
					</A>
				</div>

				<div class="main-container">
					&copy; {new Date().getFullYear()} | Home Energy and Data Services Ltd | Development
					by Dynamic Array Ltd | v{__APP_VERSION__} | All Rights Reserved
				</div>
			</footer>
		</>
	);
};
